import { FC, MouseEvent, useState } from 'react';
import styled from 'styled-components';

import Button from '@/components/Button';
import AuthModal from '@/components/Layout/AuthModal';
import UploadModal from '@/components/UploadModal';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 26px;
  position: relative;
`;

const UploadButton = styled(Button)`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray};
  border: 0;
  height: 36px;
  padding: 0 15px;
  border-radius: 100px;
  svg {
    margin-right: 8px;
  }
  &:hover,
  &:active {
    color: ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

export const Avatar = styled.div`
  border: 1px solid rgba(144, 144, 144, 0.3);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  object-fit: cover;
  background: ${({ theme }) => theme.colors.white};
`;

const ButtonsHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  padding-right: 32px;
  margin-right: 32px;
  border-right: 1px solid #e9e9e9;
`;

const Header: FC = () => {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  return (
    <Wrap>
      <ButtonsHolder>
        <UploadButton
          onClick={(e: MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            setIsUploadModalOpen(true);
          }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.19922 5.91797L8.99922 3.10547L11.7992 5.91797"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 10.6074V3.10742"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.3996 9.53613V14.3576C15.3996 14.4996 15.3434 14.6359 15.2434 14.7364C15.1434 14.8368 15.0077 14.8933 14.8663 14.8933H3.13294C2.99149 14.8933 2.85584 14.8368 2.75582 14.7364C2.6558 14.6359 2.59961 14.4996 2.59961 14.3576V9.53613"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Upload CSV
        </UploadButton>
        <UploadModal
          show={isUploadModalOpen}
          onClose={() => setIsUploadModalOpen(false)}
        />
      </ButtonsHolder>
      <AuthModal />
    </Wrap>
  );
};

export default Header;
